import {isEqual} from "lodash";
import {grey} from "@mui/material/colors";

const CREATED = "created";
const UPDATED = "updated";
const ROW_STATE = "rowState";
const STATE_ROWS = "stateRows";
const UPDATED_ORIGIN = "updatedOrigin";

const setDataState = (e) => {
  const eType = e.type && e.type === "cellValueChanged" ? e.type : "RowNode";
  const rowNode = e.type && e.type === "cellValueChanged" ? e.node : e;
  const gridApi = e.beans? e.beans.gridApi : e.api;
  const rowId = Number(rowNode.id);

  const allDisplayedColumns = gridApi.getAllDisplayedColumns();
  const firstDisplayedColumn = allDisplayedColumns ? allDisplayedColumns[0] : null;
  const lastFocusedCell = eType === "cellValueChanged" ? gridApi.getFocusedCell() : {rowIndex : rowNode.rowIndex, column : firstDisplayedColumn};

  if (!Object.prototype.hasOwnProperty.call(gridApi, STATE_ROWS)) {
    gridApi[STATE_ROWS] = {created: [], updated: []};
  }

  const createdRows = gridApi[STATE_ROWS]?.[CREATED];
  const updatedRows = gridApi[STATE_ROWS]?.[UPDATED];

  if (eType === "RowNode") {
    if (!createdRows.includes(rowId) && !rowNode.data.id) {
      rowNode[ROW_STATE] = CREATED;
      createdRows.push(rowId);
    } else if(!updatedRows.includes(rowId) && rowNode.data.id) {
      rowNode[ROW_STATE] = UPDATED;
      updatedRows.push(rowId);
    }
  } else {
    if (rowNode[ROW_STATE] !== CREATED) {
      if (!isEqual(e.oldValue, e.newValue)) {
        if (!Object.prototype.hasOwnProperty.call(gridApi, UPDATED_ORIGIN)) {

          gridApi[UPDATED_ORIGIN] = {};
        }
        if (!Object.prototype.hasOwnProperty.call(gridApi[UPDATED_ORIGIN], rowId) && !updatedRows.includes(rowId)) {
          gridApi[UPDATED_ORIGIN][rowId] = {...rowNode.data, [e.column.colId]: e.oldValue};
          rowNode[ROW_STATE] = UPDATED;
          updatedRows.push(rowId);
        } else {
          const originalRowData = gridApi[UPDATED_ORIGIN][rowId];
          const currentRowData = {...rowNode.data};

          if (isEqual(originalRowData, currentRowData)) {
            delete gridApi[UPDATED_ORIGIN][rowId];
            delete rowNode[ROW_STATE];
            updatedRows.splice(updatedRows.indexOf(rowId), 1);
          }
        }
      }
    }
  }

  gridApi.redrawRows({rowNodes: [rowNode]});

  if (lastFocusedCell) {
    gridApi.setFocusedCell(lastFocusedCell.rowIndex, lastFocusedCell.column);

    if (eType !== "RowNode") {
      if (e.rowIndex !== lastFocusedCell.rowIndex || e.column !== lastFocusedCell.column) {
        gridApi.startEditingCell({rowIndex : lastFocusedCell.rowIndex, colKey: lastFocusedCell.column});
      }
    }
  }
}

const initialize = (gridApi) => {
  if (gridApi) {
    gridApi[STATE_ROWS] = {created: [], updated: []};
    gridApi[UPDATED_ORIGIN] = {};
  }
}

const getAllStateRow = (gridApi) => {
  return gridApi[STATE_ROWS];
}

const getRowState = (gridApi, rowIndex) => {
  const rowState = gridApi.getRowNode(rowIndex)[ROW_STATE];

  return rowState ? rowState : "none";
}

const getStateRows = (gridApi, rowState) => {
  return getAllStateRow(gridApi)[rowState];
}

const getStateData = (gridApi, rowStatus) => {
  const rows = getAllStateRow(gridApi)[rowStatus];
  const rowDatas = [];

  for (const rowIndex of rows) {
    const rowData = {...gridApi.getRowNode(rowIndex)?.data};
    if(rowStatus === UPDATED) {
      rowData.rowIndex = rowIndex;
    }

    rowDatas.push(rowData);
  }

  return rowDatas;
}

const getAllStateData = (gridApi) => {
  return [...getStateData(gridApi, CREATED), ...getStateData(gridApi, UPDATED)];
}

const getUpdateOrigin = (gridApi) => {
  return gridApi[UPDATED_ORIGIN];
}

const getRowStyles = (e, addStyles = false) => {
  let styles = {};

  if (e.node[ROW_STATE] === CREATED) {
    styles.backgroundColor = "#FFFFD2";

    if (addStyles) {
      styles = {...styles, ...addStyles};
    }
  }

  if (e.node.rowPinned) {
    styles.backgroundColor = grey[100];
    styles.fontWeight = 500;
  }

  return styles;
}

const getRowClass = (e) => {
  if (e.node[ROW_STATE] === UPDATED) {
    return 'updateRow';
  }
  return null;
}

const setRowState = (gridApi, rowId, rowState) => {
  const rowNode = gridApi.getRowNode(rowId);
  rowNode[ROW_STATE] = rowState;
  gridApi[STATE_ROWS][rowState].push(rowId);

  gridApi.redrawRows({ rowNodes: [rowNode] });
}

const deleteState = (gridApi, deleteNodes) => {
  const deleteIds = deleteNodes.map((node) => { return node.id });
  const deleteRows =  deleteNodes.map((node) => { return node.data });

  const originState = [];
  const updatedOriginState = gridApi[UPDATED_ORIGIN];

  gridApi.forEachNode((node) => {
    if(node[ROW_STATE]){
      originState.push(node);
    }
  });

  initialize(gridApi);

  originState.forEach((node) => {
    const state = node[ROW_STATE];

    if(state){
      if(!deleteIds.includes(node.id)) {
        setDataState(node);
      }
    }
  });

  gridApi[UPDATED_ORIGIN] = updatedOriginState;

  gridApi.applyTransaction({remove: deleteRows});
}

const DataState = {
  setDataState,
  initialize,
  getAllStateRow,
  getStateRows,
  getRowState,
  getAllStateData,
  getStateData,
  getRowStyles,
  getRowClass,
  getUpdateOrigin,
  setRowState,
  deleteState
}

export default DataState;